import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=04de8282&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=js&"
export * from "./Forget.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Auth.css?vue&type=style&index=0&id=04de8282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de8282",
  null
  
)

export default component.exports